import React, { Fragment, useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppleLoginButton } from "react-social-login-buttons";
import Cookies from "js-cookie";
import axios from "axios";
import { loadSanadBranding } from "../utils/loadSanadBranding";

const { config } = require("../../api/api");

function SanadOmanVisaPaymentStatus() {
  const [applicationId, setApplicationId] = useState("");
  const [applicationData, setApplicationData] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("success");
  const [userData, setUserData] = useState({});
  const [vendorKey, setVendorKey] = useState(
    "c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ=="
  );
  const [loading, setLoading] = useState("");
  const [usrtok, setUsrtok] = useState("");

  const base_url = config.baseURL;

  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const appId = urlParams.get("application_id");
      const status = urlParams.get("status");
      if (appId) {
        setApplicationId(atob(appId));
        // setPaymentStatus(status);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }, []);

  useEffect(() => {
    loadSanadBranding();
  }, []);

  // ✅ Load SmartBox script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = config.amwalpayURL;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const storedUserString = Cookies.get("userData");
    if (storedUserString !== undefined) {
      const user_data = JSON.parse(storedUserString);
      setUserData(user_data);
      setUsrtok(user_data.access_token);
    }
  }, []);

  useEffect(() => {
    if (vendorKey && applicationId) {
      const app_data = { application_id: applicationId };
      fetch(base_url + "/get_sanad_oman_visa_order", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + vendorKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(app_data),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message === "success") {
            if (typeof data.result.sanad_details === "string") {
              data.result.sanad_details = JSON.parse(data.result.sanad_details);
            }
            setApplicationData(data.result);
          }
        })
        .catch((error) => {
          toast.error(error.message);
          console.error("Error fetching oman visa app :", error);
        });
    }
  }, [vendorKey, applicationId]);

  const handleSanadHomeNav = () => {
    const regex = /^(ftp|http|https):\/\/[^ "]+$/;
    var isValidUrl = regex.test(applicationData.sanad_details?.return_url);

    if (isValidUrl) {
      window.location.href =
        applicationData.sanad_details?.return_url +
        "?applicationid=" +applicationData?.application_id+
        "&sanad_reference_no=" +
        applicationData?.sanad_reference_no;
    } else {
      window.location.reload();
    }
  };

  const getUserType = () => {
    if (userData.agency_name) return "agent";
    if (userData.type === "staff" && userData.staff_first_name) return "staff";
    if (userData.first_name && userData.last_name) return "user";
    return "";
  };

  // const openPaymentGateway = async (app_id) => {
  //   if (!app_id || !vendorKey) {
  //     console.error(" Missing appId or vendorKey");
  //     return;
  //   }

  //   setLoading(true);

  //   const pay_data = {
  //     application_id: app_id,
  //     user_type: getUserType(),
  //     is_live: "true",
  //     save_selection: "true",
  //     currency: "OMR",
  //     fee_omr: 45,
  //     description: "Oman Visa Payment",
  //     token: userData.access_token,
  //   };

  //   try {
  //     const res = await fetch(`${base_url}/create_sanad_oman_visa_payment`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${vendorKey}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(pay_data),
  //     });

  //     if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

  //     const result = await res.json();
  //     if (result.message === "success") {
  //       const parsedata = JSON.parse(result.result.payment_details);
  //       const { secureHash, trxParams } = parsedata;

  //       if (!window.SmartBox || !window.SmartBox.Checkout) {
  //         throw new Error("SmartBox payment gateway not loaded");
  //       }

  //       window.SmartBox.Checkout.configure = {
  //         MID: trxParams.MerchantId,
  //         TID: trxParams.TerminalId,
  //         CurrencyId: trxParams.CurrencyId,
  //         AmountTrxn: trxParams.Amount,
  //         MerchantReference: trxParams.MerchantReference,
  //         LanguageId: "en",
  //         PaymentViewType: 1,
  //         TrxDateTime: trxParams.TrxDateTime,
  //         SessionToken: trxParams.SessionToken,
  //         SecureHash: secureHash,

  //         completeCallback: async (data) => {
  //           setLoading(true);
  //           try {
  //             const verifyRes = await axios.post(
  //               `${base_url}/sanad_oman_visa_payment_status`,
  //               data.data
  //             );
  //             if (verifyRes.data.valid) {
  //               window.location.href = verifyRes.data.data;
  //             }
  //           } catch (err) {
  //             console.error("Verification failed:", err);
  //           } finally {
  //             setLoading(false);
  //           }
  //         },

  //         errorCallback: (error) => {
  //           console.error("❌ Payment Error:", error);
  //           setLoading(false);
  //           window.location.href = `/oman-visa-form-status?application_id=${btoa(
  //             app_id
  //           )}&payment_status=failed`;
  //         },

  //         cancelCallback: () => {
  //           console.log("⚠️ Payment Cancelled:");
  //           setLoading(false);
  //         },
  //       };

  //       window.SmartBox.Checkout.showSmartBox();
  //     } else {
  //       throw new Error(result.message || "Payment creation failed");
  //     }
  //   } catch (err) {
  //     console.error("Error creating payment:", err);
  //     setLoading(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  
    const openPaymentGateway = async (app_id) => {
      if (!app_id || !vendorKey) {
        console.error(" Missing appId or vendorKey");
        return;
      }
  
      setLoading(true);
  
      const pay_data = {
        application_id: app_id,
        is_live: "true",
        save_selection: "true",
        currency: "OMR",
        fee_omr: 45,
        description: "Oman Visa Payment",
      };
  
      try {
        const res = await fetch(`${base_url}/create_sanad_oman_visa_payment`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${vendorKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(pay_data),
        });
  
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
        const result = await res.json();
        if (result.message === "success") {
          const parsedata = JSON.parse(result.result.payment_details);
          const { secureHash, trxParams } = parsedata;
  
          if (!window.SmartBox || !window.SmartBox.Checkout) {
            throw new Error("SmartBox payment gateway not loaded");
          }
         
  
          window.SmartBox.Checkout.configure = {
            MID: trxParams.MerchantId,
            TID: trxParams.TerminalId,
            CurrencyId: trxParams.CurrencyId,
            AmountTrxn: trxParams.Amount,
            MerchantReference: trxParams.MerchantReference,
            LanguageId: "en",
            PaymentViewType: 1,
            TrxDateTime: trxParams.TrxDateTime,
            SessionToken: trxParams.SessionToken,
            SecureHash: secureHash,
  
            completeCallback: async (data) => {
              try {
                setLoading(true);
                const verifyRes = await axios.post(
                  `${base_url}/sanad_oman_visa_payment_status`,
                  data.data
                );
                if (verifyRes.data.valid) {
                  window.location.href = verifyRes.data.data;
                  return;
                }
              } catch (err) {
                setLoading(false);
                console.error("Verification failed:", err);
              }
            },
  
            errorCallback: (error) => {
              console.error("❌ Payment Error:", error);
              setLoading(true);
              window.location.href = `/sanad-oman-visa-status?application_id=${btoa(
                app_id
              )}&payment_status=failed`;
            },
  
            cancelCallback: () => {
              console.log("⚠️ Payment Cancelled:");
              setLoading(false);
            },
          };
  
          window.SmartBox.Checkout.showSmartBox();
        } else {
          throw new Error(result.message || "Payment creation failed");
        }
      } catch (err) {
        console.error("Error creating payment:", err);
        toast.error(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

  const handleRetryPayment = () => {
    const app_id = applicationData.application_id;

    setTimeout(() => {
      openPaymentGateway(app_id);
    }, 1000);
  };

  return (
    <Fragment>
      <div className="container-fluid bg-breadcrumb">
        <div className="row justify-content-center mt-5">
          <div className="col-lg-6 col-md-9">
            {applicationData &&(<div className="row mb-2">
              <div className="col-lg-6 col-md-6 text-start">
                <h2>Payment Status</h2>
              </div>
              <div className="col-lg-6 col-md-6 text-right">
                <h2>حالة الدفع</h2>
              </div>
            </div>)}

            <div className="row justify-content-center">
              <div className="col-12">
                {applicationData && (
                  <div className="card py-4 ">
                    <div className="text-center">
                      {applicationData?.payment_status === "success" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="45"
                          height="45"
                          fill="#28a745"
                          className="bi bi-check-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="45"
                          height="45"
                          fill="#dc3545"
                          className="bi bi-x-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                        </svg>
                      )}
                    </div>
                    <div className="card-body">
                      <div
                        className={`alert ${
                          applicationData?.payment_status === "success"
                            ? "alert-success"
                            : "alert-danger"
                        }`}
                      >
                        <h5 className="alert-heading">
                          {applicationData?.payment_status === "success"
                            ? "✓ " + "Form Submitted Successfully!"
                            : "✗ " + "Payment Failed!"}
                        </h5>
                        <p className="mb-0">
                          {applicationData?.payment_status === "success"
                            ? "Your Oman visa application has been received and payment processed successfully. We will contact you shortly with further details."
                            : "Your payment could not be processed. Please try again or contact support for assistance."}
                        </p>
                      </div>

                      {/* Travel Information */}
                      <div className="mb-4 mt-4">
                        <div className="row">
                          <div className="col-md-12 ">
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Sanad Reference No
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                {applicationData?.sanad_reference_no}
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Application ID
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                {applicationData?.application_id}
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Applicant Name
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                {applicationData?.full_name || ""}
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Visa Type
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                {applicationData?.visa_type || "-"}
                              </span>
                            </div>

                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Entry Date
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                {applicationData?.entry_date || ""}
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Email
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                {applicationData?.email || ""}
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Payment Ref No
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                <span>
                                  {applicationData?.payment_reference_no}
                                </span>
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span
                                className="fw-bold"
                                style={{ minWidth: "150px", fontWeight: "600" }}
                              >
                                Payment Status
                              </span>
                              <span>:&nbsp;</span>
                              <span className="ms-2">
                                <span
                                  className={
                                    applicationData?.payment_status ===
                                    "success"
                                      ? "text-success"
                                      : "text-danger"
                                  }
                                  style={{ fontWeight: 600 }}
                                >
                                  {applicationData?.payment_status === "success"
                                    ? "Success"
                                    : "Failed"}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-md-flex gap-4">
                        {applicationData?.payment_status === "success" ? (
                          <>
                            <button
                              className={`mb-3`}
                              onClick={handleSanadHomeNav}
                            >
                              Go To Sanad
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className={`mb-3 mr-3`}
                              onClick={handleRetryPayment}
                              disabled={loading}
                            >
                              {loading ? "Processing" : "Retry Payment"}
                            </button>
                            {/* <button
                              className={`mb-3`}
                              onClick={handleSanadHomeNav}
                            >
                              Go To Sanad
                            </button> */}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mb-5">
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={5000} />
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
  );
}

export default SanadOmanVisaPaymentStatus;
